import { ACHIEVEMENTS, type StatsView } from '@tm/shared';

export function Achievements({ stats }: { stats: StatsView }) {
  const byCode = new Map(stats.achievements.map((s) => [s.code, s]));
  const list = ACHIEVEMENTS.map((a) => ({ def: a, state: byCode.get(a.code) }));
  const unlocked = list.filter((x) => x.state?.unlockedAt);
  const locked = list.filter((x) => !x.state?.unlockedAt);

  return (
    <div className="stack">
      <div className="row between">
        <h1>Награды</h1>
        <span className="pill">{unlocked.length} / {list.length}</span>
      </div>

      {unlocked.length > 0 && (
        <div className="card">
          <h3>Получено</h3>
          {unlocked.map(({ def }) => (
            <div className="ach" key={def.code}>
              <span className="ico">{def.emoji}</span>
              <span className="grow">
                <b>{def.title}</b>
                <div className="small dim">{def.description}</div>
              </span>
              <span className="dim">✓</span>
            </div>
          ))}
        </div>
      )}

      <div className="card">
        <h3>В процессе</h3>
        {locked.map(({ def, state }) => (
          <div className="ach locked" key={def.code}>
            <span className="ico">{def.secret ? '❔' : def.emoji}</span>
            <span className="grow">
              <b>{def.secret ? 'Секретная награда' : def.title}</b>
              <div className="small dim">{def.secret ? 'Откроется сама' : def.description}</div>
              {!def.secret && (
                <>
                  <div className="bar"><i style={{ width: `${(state?.progress ?? 0) * 100}%` }} /></div>
                  <div className="small dim">{state?.progressLabel ?? ''}</div>
                </>
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
